import { render, staticRenderFns } from "./PersentageChart.vue?vue&type=template&id=1cd014af&scoped=true&"
import script from "./PersentageChart.vue?vue&type=script&lang=js&"
export * from "./PersentageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd014af",
  null
  
)

export default component.exports